module.exports = __webpack_public_path__ + "img/hb-apres.b226d949.jpg";